<template>

  <div class="d-flex justify-content-center my-3">
    <span class="badge badge-pill badge-light text-muted text-uppercase font-weight-normal px-3 py-1">{{ label }}</span>
  </div>

</template>

<script>
import moment from 'moment'

export default {
  name: 'MessageDateDivider',
  props: {
    date: {
      type: [String, Number, Date],
      default: null
    }
  },
  computed: {
    // human-friendly day label: Today / Yesterday / weekday / full date
    label () {
      if (!this.date) {
        return ''
      }
      const date = moment(this.date).locale(this.$i18n.locale)
      const today = moment().startOf('day')
      const target = moment(this.date).startOf('day')
      const diff = today.diff(target, 'days')

      if (diff === 0) {
        return this.$t('Today')
      } else if (diff === 1) {
        return this.$t('Yesterday')
      } else if (diff < 7) {
        return date.format('dddd')
      }
      return date.format('LL')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Messaging/thread/MessageDateDivider.vue